/**
 * Remove empty p tags accidentally placed by wordpress editor
 */
export default function removeEmptyPTags(){
    const elements = document.querySelectorAll("p");
    Array.prototype.forEach.call(elements, function (el, i) {
        let content = el.innerHTML;
        content = content.replace(/\s+/g, "");
        if (!content) {
            el.parentNode.removeChild(el);
        }
    });
}